import React from 'react'
import { NUM_CATEGORIES } from '@mc/constants'
import { useTranslation } from '@mc/i18n'
import { getNumberOfInstructors } from '@mc/instructors'
import CTA from 'components/CTA'
import { PricingText } from 'components/PricingText'
import { useLanguageCleanupExpGetAllClasses } from 'experiments/pen-5840_v1_core_membership_language_cleanup'

export const Callout = () => {
  const { t } = useTranslation('@mc/next')
  const languageCleanupExpGetAllClasses = useLanguageCleanupExpGetAllClasses()

  return (
    <div className='container d-flex flex-column flex-fill justify-content-end mc-py-4 mc-text--center'>
      <h2 className='mc-text-h4 mc-mb-2'>{t('nav.callout.title')}</h2>
      <p className='mc-mb-5'>
        {languageCleanupExpGetAllClasses ??
          t('nav.callout.subtitle', {
            instructors: getNumberOfInstructors(),
            categories: NUM_CATEGORIES,
          })}
      </p>
      <CTA
        fullWidth
        trackProps={{
          category: 'video-playlist-module',
          content_type: 'product',
          level: 'secondary',
          location: 'navigation',
          page_category: 'class',
          page_source: 'navigation',
        }}
      />
      <p className='mc-mt-3'>
        <PricingText translationKey='short' />
      </p>
    </div>
  )
}
